import React from 'react';

import {
  Badge,
  Button,
} from 'antd';
import { BsChevronDown } from 'react-icons/bs';

type Props = {
  showScrollDown: boolean;
  handleScrollToBottom: () => void;
  badgeCount: number;
};

const CommunityChatScrollTobuttomButton: React.FC<Props> = ({
  showScrollDown,
  handleScrollToBottom,
  badgeCount,
}) => {
  if (!showScrollDown) return null;
  return (
    <div
      style={{
        position: 'fixed',
        right: '20px',
        bottom: '180px',
        zIndex: 100,
      }}>
      <Badge
        count={badgeCount}
        size="small"
        style={{ backgroundColor: 'green' }}>
        <Button
          type="primary"
          shape="circle"
          icon={<BsChevronDown />}
          onClick={handleScrollToBottom}
        />
      </Badge>
    </div>
  );
};

export default CommunityChatScrollTobuttomButton;
